import React from 'react';
import { SxProps, TablePagination, Theme, Typography, useMediaQuery } from '@mui/material';
import { useIntl } from 'react-intl';
import TablePaginationActions from './TablePaginationActions';

export interface IProps {
  id?: number;
  label?: string;
  page: number;
  realPerPage?: number;
  perPage: number;
  total: number;
  fetchRows?: any;
  statuses?: string;
  companyId?: string;
  rowsPerPageOptions?: number[];
  customStyles?: any;
}

const TablePaginator: React.FC<IProps> = ({
  id,
  label,
  page,
  realPerPage,
  perPage,
  total,
  fetchRows,
  statuses,
  companyId,
  rowsPerPageOptions = [10, 20, 50],
  customStyles,
}) => {
  const intl = useIntl();
  const isMobile = useMediaQuery('(max-width:1050px)');
  const isCorrectPerPage =
    window.location.pathname === '/orders/list/full' ||
    window.location.pathname === '/products/offers/moderation';

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (id) {
      fetchRows({ page: newPage + 1, perPage, categoryId: id });
    } else if (statuses) {
      fetchRows({ page: newPage + 1, perPage, statuses });
    } else if (companyId) {
      fetchRows({ page: newPage + 1, perPage, companyId });
    } else {
      fetchRows({ page: newPage + 1, perPage });
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newPerPage = parseInt(event.target.value, 10);
    localStorage.setItem('productsPerPage', String(newPerPage));

    if (id) {
      fetchRows({ page: 1, perPage: newPerPage, categoryId: id });
    } else if (statuses) {
      fetchRows({ page: 1, perPage: newPerPage, statuses });
    } else if (companyId) {
      fetchRows({ page: 1, perPage: newPerPage, companyId });
    } else {
      fetchRows({ page: 1, perPage: newPerPage });
    }
  };

  return (
    <TablePagination
      component='div'
      onChange={() => { }}
      rowsPerPageOptions={rowsPerPageOptions}
      count={total}
      rowsPerPage={perPage}
      sx={[
        {
          width: '100%',
          overflow: isMobile ? 'unset' : 'hidden',
          '& >div': {
            display: 'grid',
            // justifyContent: 'center',
            // flexDirection: 'row-reverse',
            // flexWrap: 'wrap',
            width: '100%',
            paddingRight: 0,
            paddingLeft: 0,

            '& > div:empty': {
              display: 'none !important',
            },
            '& > p:nth-child(2)': {
              marginBottom: '0 !important',
              marginTop: '0 !important',
              display: 'none !important',
              '& p': {
                marginBottom: '0 !important',
                marginTop: '0 !important',
              },
            },
            '& > div:nth-child(3)': {
              gridArea: '1 / 5 / 2 / 6',
              position: isMobile ? 'absolute' : 'unset',
              top: '-30px',
              justifySelf: 'end',
              right: 0,
              marginRight: 0,
            },
            '& > p:nth-child(4)': {
              marginBottom: '0 !important',
              display: 'none !important',
              marginTop: '0 !important',

              '& div': {
                marginBottom: '0 !important',
                marginTop: '0 !important',
              },
            },
            '& > div:nth-child(5)': {
              margin: 0,
              gridArea: isMobile ? '1 / 1 / 2 / 4' : '1 / 3 / 2 / 4',
              justifySelf: 'center',
            },
          },
        },
        customStyles,
      ]}
      page={page - 1}
      labelRowsPerPage={
        <Typography
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: 10,
            fontSize: 18,
            fontWeight: 'normal',
          }}
        >
          {label}
        </Typography>
      }
      slotProps={{
        select: {
          // inputProps: { 'aria-label': 'first page' },
          // native: true,
          sx: {
            fontSize: 18,
            fontWeight: 'normal',
            backgroundColor: '#a3a7b819',
            borderRadius: '4px !important',
            width: 72,
            '& .MuiTablePagination-select': {
              textAlign: 'center',
            },
          },
          MenuProps: {
            // sx: { backgroundColor: 'blue' },
            PaperProps: {
              sx: {
                maxHeight: 200, // Ограничение высоты выпадающего списка
                paddingTop: '0 !important',
                paddingBottom: '0 !important',
                borderRadius: '4px !important',
                marginTop: '8px !important',
                border: 'none !important',
                backgroundColor: '#fff',
                '& ul': {
                  paddingTop: '0 !important',
                  paddingBottom: '0 !important',
                },
                '& .MuiMenuItem-root': {
                  fontSize: 18,
                  borderBottom: '1px solid #e9eaf0 !important',
                  borderRadius: '0 !important',
                  '& .Mui-selected': {
                    // backgroud
                    borderRadiut: 'none !important',
                    backgroundColor: 'red',
                  },
                  '&:hover': {
                    backgroundColor: '#f5f5f5', // Фон элементов при наведении
                  },
                  '&:focus': {
                    borderRadius: 4,
                  },
                  '& option': {
                    textAlign: 'center',
                    borderRadius: '0 !important',
                  },
                },
              },
            },
          },
        },
      }}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      ActionsComponent={TablePaginationActions}
      labelDisplayedRows={({ from, to, count }) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: 11,
            fontSize: 18,
            fontWeight: 'normal',
          }}
        >
          {`${from}${realPerPage === 1 ? '' : '-'}${realPerPage === 1 ? '' : to
            } ${intl.formatMessage({
              id: 'TABLE.FROM.LABEL',
            })} ${count}`}
        </div>
      )}
    />
  );
};

export default TablePaginator;
